import queryString from 'query-string';
import { isEmpty, omit } from 'lodash';
import { getHistory } from '@flow/libs/router/history';

export const UTM_SOURCE = {
  DIRECT_LINK: 'direct_link',
  EMAIL: 'email',
  SMS: 'sms',
  CONTRACT_LIST: 'contract_list',
  AI_INSIGHTS_MODAL: 'ai_insights_modal',
};

let utmSource = UTM_SOURCE.DIRECT_LINK;

const setUtmSource = (source: string) => {
  utmSource = source || UTM_SOURCE.DIRECT_LINK;
};

export const getUtmSource = () => utmSource;

declare global {
  interface Window {
    getUtmSource: () => string;
  }
}

/**
 * Handles UTM source tracking from URL parameters and cleans the URL
 *
 * This function:
 * 1. Extracts utm_source from URL query parameters
 * 2. Stores the utm_source value for tracking purposes
 * 3. Removes utm_source from the URL to keep it clean
 * 4. Updates the browser history with the cleaned URL
 *
 * @param location - The current browser location object containing URL information
 */
export const handleUtmSource = (location: Location) => {
  if (location.search) {
    const parsedSearch = queryString.parse(location.search);
    if (parsedSearch.utm_source) {
      // Handle multiple utm_source parameters
      if (Array.isArray(parsedSearch.utm_source)) {
        setUtmSource(parsedSearch.utm_source[0]);
      } else {
        setUtmSource(parsedSearch.utm_source);
      }
      const cleanSearchObject = omit(parsedSearch, 'utm_source');

      let cleanedUrl = location.pathname;
      if (!isEmpty(cleanSearchObject)) {
        cleanedUrl += `?${queryString.stringify(cleanSearchObject)}`;
      }

      const history = getHistory();
      history.replace(cleanedUrl);
      return;
    }
  }

  setUtmSource('');
};
